import { useCallback, useState } from "react";

interface Sort<T extends string> {
  key: T;
  order: Order;
}

type Order = "desc" | "asc";

export default function useSort<T extends string>(
  initialKey: T,
  initialSort: Order = "desc"
) {
  const [sort, setFullSort] = useState<Sort<T>>({
    key: initialKey,
    order: initialSort,
  });
  const resetSort = useCallback(() => {
    setFullSort({
      key: initialKey,
      order: initialSort,
    });
  }, [initialKey, initialSort]);
  const setSort = useCallback(
    (key) => {
      if (sort.key === key) {
        setFullSort({
          key: sort.key,
          order: sort.order === "desc" ? "asc" : "desc",
        });
      } else {
        setFullSort({
          key,
          order: "desc",
        });
      }
    },
    [sort.key, sort.order]
  );
  const toggleOrder = useCallback(() => {
    setFullSort({
      key: sort.key,
      order: sort.order === "desc" ? "asc" : "desc",
    });
  }, [sort.key, sort.order]);
  return {
    sort,
    setSort,
    toggleOrder,
    resetSort,
  };
}
